import { useEffect, useState } from "react";

const useElementHeight = (selector, fallback = 0, enabled = true) => {
  const [height, setHeight] = useState(fallback);

  useEffect(() => {
    if (!enabled) return undefined;
    const measure = () => {
      const h = [...document.querySelectorAll(selector)].reduce(
        (max, el) => Math.max(max, el.offsetHeight),
        0,
      );
      if (h) setHeight((prev) => (Math.abs(prev - h) > 1 ? h : prev));
    };
    measure();
    const t = setTimeout(measure, 300);
    window.addEventListener("resize", measure);
    window.addEventListener("orientationchange", measure);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", measure);
      window.removeEventListener("orientationchange", measure);
    };
  }, [selector, enabled]);

  return height;
};

export default useElementHeight;
